var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#60C67C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.3333C32 26.7459 31.8314 27.1416 31.5314 27.4333C31.2313 27.725 30.8243 27.8889 30.4 27.8889H19.2L16 31V18.5556C16 18.143 16.1686 17.7473 16.4686 17.4556C16.7687 17.1639 17.1757 17 17.6 17H30.4C30.8243 17 31.2313 17.1639 31.5314 17.4556C31.8314 17.7473 32 18.143 32 18.5556V26.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.4b6fc66fa86c04427c5d0abea5bc2d02.svg";
export { ForwardRef as ReactComponent };